import { useSearchParams } from "react-router-dom";
import { MaskLines, Reveal } from "../components/anim";
import { Eyebrow } from "../components/ui-bits";
import QuoteForm from "../components/QuoteForm";
import { CONTACTS } from "../data/site";
import { Phone, MessageCircle, ShieldCheck } from "lucide-react";
import useSEO from "../hooks/useSEO";

export default function Contatti() {
  const [params] = useSearchParams();
  const tipo = params.get("tipo") || "";
  useSEO(
    "Contatti e preventivi: richiedi il tuo preventivo | Sprizziamoci",
    "Richiedi un preventivo personalizzato per il tuo evento: matrimoni, feste private, eventi aziendali e manifestazioni. Telefono e WhatsApp: +39 340 384 5845."
  );
  return (
    <article data-testid="contatti-page">
      <section className="pt-32 md:pt-44 pb-14">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <Eyebrow>Contatti e preventivi</Eyebrow>
          <MaskLines
            lines={["IL TUO EVENTO MERITA", "IL SUO SPRIZZIAMOCI."]}
            as="h1"
            when="load"
            delay={0.15}
            lineClass="font-display font-semibold tracking-tight leading-[1] text-[clamp(2.4rem,6vw,5rem)]"
            className="mt-6"
          />
          <Reveal delay={0.3}>
            <p className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-white/65">
              Raccontaci la festa: il preventivo si costruisce sul tuo evento. Nessun prezzo
              fisso.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="mx-auto max-w-7xl px-5 md:px-8 grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <QuoteForm initialTipo={tipo} />
          </div>

          <aside className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="rounded-3xl border border-white/[0.08] bg-brand-surface/40 p-8 md:p-10 lg:sticky lg:top-28">
                <p className="eyebrow mb-6">Preferisci parlarne a voce?</p>
                <a
                  href={CONTACTS.phoneHref}
                  data-testid="contacts-phone-card"
                  className="group flex items-center gap-5 rounded-2xl border border-white/[0.08] bg-brand-ink/60 p-6 transition-colors duration-300 hover:border-brand-orange/50"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-orange text-brand-ink shrink-0">
                    <Phone size={19} />
                  </span>
                  <span>
                    <span className="block text-xs uppercase tracking-[0.2em] text-white/50">
                      Chiamaci
                    </span>
                    <span className="block mt-1 font-display text-2xl font-semibold group-hover:text-brand-orange transition-colors duration-300">
                      {CONTACTS.phoneDisplay}
                    </span>
                  </span>
                </a>
                <a
                  href={CONTACTS.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contacts-whatsapp-card"
                  className="group mt-4 flex items-center gap-5 rounded-2xl border border-white/[0.08] bg-brand-ink/60 p-6 transition-colors duration-300 hover:border-brand-orange/50"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-orange text-brand-ink shrink-0">
                    <MessageCircle size={19} />
                  </span>
                  <span>
                    <span className="block text-xs uppercase tracking-[0.2em] text-white/50">
                      Scrivici su
                    </span>
                    <span className="block mt-1 font-display text-2xl font-semibold group-hover:text-brand-orange transition-colors duration-300">
                      WhatsApp
                    </span>
                  </span>
                </a>
                <div className="mt-8 flex gap-3 rounded-2xl border border-white/[0.08] p-5">
                  <ShieldCheck size={18} className="text-brand-orange shrink-0 mt-0.5" />
                  <p className="text-xs leading-relaxed text-white/50">
                    I dati delle richieste vengono usati esclusivamente per risponderti e
                    costruire il preventivo.{" "}
                    <a href="/privacy" data-testid="contacts-privacy-link" className="text-brand-orange underline underline-offset-2">
                      Informativa privacy
                    </a>
                  </p>
                </div>
              </div>
            </Reveal>
          </aside>
        </div>
      </section>
    </article>
  );
}
